/**
 * Created by Carsten Bühler
 * User: CBuehler on 12.02.2016
 * Copyright: xdot GmbH 2015
 */

'use strict';

//Includes
import React from 'external/react';
import {
    AppContext,
    ContextContainer,
    DataUtil,
    PortletComponent,
    ScrollableDataListRV,
    wrapWithCommonFormContainer,
    FormActions
} from 'plugin/liferay-widgets-react-web';

import { Button, Col, Container, Row } from 'external/react-bootstrap';

import { getBomListStore, getFliwasPermissionStore, getNamedListStore } from '../stores/StoreFactory';
import BomListWidgetConfigForm from './BomListWidgetConfigForm';
import { ClassNames } from '../constants/Constants';
import BomListActions from '../actions/BomListActions';
import NamedListActions from '../actions/NamedListActions';
import FliwasObjectListItem from '../components/FliwasObjectListItem';
import AssetLinkChooser from '../components/AssetLinkChooser';
import NamedListWebApi from '../webapi/NamedListWebApi';
import Icon from '../components/Icon';
import { hasEditPermissionAndGroup } from '../utils/editPermissionUtil';
import FliwasPermissionActions from '../actions/FliwasPermissionActions';

const BomListStore = getBomListStore(AppContext);
const NamedListStore = getNamedListStore(AppContext);
const fliwasPermissionStore = getFliwasPermissionStore(AppContext);

const BomListWidgetConfigFormHoc = wrapWithCommonFormContainer(BomListWidgetConfigForm);
const AssetLinkChooserHoc = wrapWithCommonFormContainer(AssetLinkChooser);

class BomListWidget extends PortletComponent {

    constructor(props) {
        super(props);

        this.DATA = {
            SELECTED_NAMED_LIST: this.withCtx('_SelectedNamedList'),
            SELECT_OBJECT_LIST: this.withCtx('_SelectedObjectList'),
            FORM_ADD_OBJECT: this.withCtx('_FormAddObject'),
            NAMED_LIST_PERMISSION: this.withCtx('_NamedListPermission')
        };

        this.selectNamedList = this.selectNamedList.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        const linkedQuery = {
            $byEntries: ClassNames.AssetCategory + '/' + this.DATA.SELECTED_NAMED_LIST + '/entries',
            byClassName: ClassNames.AssetCategory
        };
        const assetCategoryId = this.props.initialConfig && this.props.initialConfig.assetCategoryId || -1;
        if (assetCategoryId > 0) {
            this.selectNamedList({ id: assetCategoryId });
        }

        FliwasPermissionActions.getPermissionState(this.DATA.NAMED_LIST_PERMISSION, {
            nameSpace: 'named-lists',
            fliwasPermission: 'manage-named-lists'
        });

        BomListActions.bomList(this.DATA.SELECT_OBJECT_LIST, { ...linkedQuery });
    }

    static getStores() {
        return [
            NamedListStore,
            BomListStore,
            fliwasPermissionStore
        ];
    }

    static calculateState(prevState, undefined, DATA) {
        return {
            config: prevState.config,
            selectedNamedList: NamedListStore.getRemoteData(DATA.SELECTED_NAMED_LIST),
            selectedObjectList: BomListStore.getRemoteData(DATA.SELECT_OBJECT_LIST),
            NAMED_LIST_PERMISSION: fliwasPermissionStore.getRemoteData(DATA.NAMED_LIST_PERMISSION),
        };
    }

    selectNamedList(namedList) {
        //Current Object
        NamedListActions.item(this.DATA.SELECTED_NAMED_LIST, { id: namedList.id });
    }

    renderConfigForm(props) {
        return (<BomListWidgetConfigFormHoc {...props} />);
    }

    configWillChange(prevConfig, nextConfig) {
        this.isRefreshing = false;
        console.log('configWillChange', prevConfig, ' ==> ', nextConfig);

        if (prevConfig.assetCategoryId !== nextConfig.assetCategoryId) {
            this.selectNamedList({ id: nextConfig.assetCategoryId });
        }
    }

    onObjectAdd() {
        FormActions.startEditFormItem(this.DATA.FORM_ADD_OBJECT, {});
    }

    onObjectAddSubmit(data) {
        const selectedList = DataUtil.asItem(this.state.selectedNamedList);
        NamedListWebApi.update({
            ...selectedList,
            entries: [...selectedList.entries, { className: data.className, classPK: data.id }]
        });
        FormActions.stopEditFormItem(this.DATA.FORM_ADD_OBJECT);
    }

    isConfigurationNeeded(config) {
        return !(config && config.assetCategoryId);
    }

    renderPortlet(config) {
        const selectedObjectListDataItem = this.state.selectedObjectList && this.state.selectedObjectList;
        const namedListPermission = this.state && this.state.NAMED_LIST_PERMISSION;
        const isEditable = hasEditPermissionAndGroup(this.state.selectedObjectList, namedListPermission, true);

        return (
            <Container fluid>
                <Row>
                    {selectedObjectListDataItem &&
                        <Col xs={12} className="nopadding">
                            {isEditable &&
                                <Button onClick={this.onObjectAdd.bind(this)} className="m-1">
                                    <Icon name="plus"/>
                                </Button>
                            }
                            <ScrollableDataListRV
                                list={selectedObjectListDataItem}
                                rowHeight={80}
                                size={config.height}
                                ListItem={FliwasObjectListItem}
                            />
                            <AssetLinkChooserHoc
                                formId={this.DATA.FORM_ADD_OBJECT}
                                onFormSubmit={this.onObjectAddSubmit.bind(this)}
                            />
                        </Col>}
                </Row>
            </Container>
        );
    }
}

BomListWidget.propTypes = {};

export default ContextContainer.create(BomListWidget);



// WEBPACK FOOTER //
// ./js/widgets/BomListWidget.jsx